import Home from './pages/Home'

const HomeRoutes = {
  routes: [
    {
      key: 'home',
      type: 'unauthorized',
      title: 'Home',
      path: `/`,
      component: Home,
      exact: true,
    },
  ],
}
export default HomeRoutes
